// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.G_G5uT {
  display: flex;
  flex-direction: column;
  width: 400px;
  background: #ffffff;
  border: 1px solid #e6e6e6;
  border-radius: 8px;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  font-family: 'Source Sans 3', sans-serif;
}

.NT48yd {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  width: 100%;
  padding: 24px 24px 0px;
}

.fP56gb {
  font-weight: 600;
  font-size: 20px;
  line-height: 1.424;
  color: #1f1f1f;
  margin: 0;
  flex: 1;
}

.set303 {
  margin: 0;
  font-weight: 500;
  font-size: 14px;
  line-height: 1.5;
  color: #666666;
}

.yKBB4J {
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 24px;
  padding: 24px;
}

.K03vGt {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.uCZWVD {
  display: flex;
  align-items: center;
  gap: 4px;
  width: 100%;
  margin-bottom: 8px;
}

.DEp9mH {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.421;
  color: #1f1f1f;
  margin: 0;
}

.b4wsKn {
  cursor: help;
  width: 12px !important;
  height: 12px !important;
}

.IvbnWX {
  display: flex;
  align-items: center;
  gap: 16px;
  width: 100%;
  justify-content: flex-start;
}

.SYVTpT {
  width: 44px;
  height: 48px;
  text-align: center;
  font-weight: 400;
  font-size: 14px;
  line-height: 1;
  color: #1f1f1f;
  background: #fafafa;
  border: 1px solid #cccccc;
  border-radius: 4px;
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease;
}

.SYVTpT:focus {
  border-color: #d64000;
  box-shadow: 0 0 0 2px rgba(214, 64, 0, 0.1);
}

.SYVTpT.CN6QQV {
  border-color: #dc3545;
  background-color: #fff5f5;
}

.SYVTpT.S9E8Iu {
  border-color: #999999;
}

.SYVTpT:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.FxqBGc {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding-top: 12px;
  max-width: 80%;
}

.VatNr0 {
  width: 16px;
  height: 16px;
  color: #dc3545;
  flex-shrink: 0;
  margin-top: 2px;
}

.IbbIwT {
  font-weight: 400;
  font-size: 12px;
  line-height: 1.4;
  color: #666666;
  margin: 0;
}

.I3RgJ5 {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  padding: 12px 24px;
}

.OloaDu {
  display: flex;
  justify-content: stretch;
  align-items: stretch;
  gap: 16px;
  padding: 0px 24px 24px;
  width: 100%;
}

.WVyxNp {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 8px 0;
  width: 100%;
  height: 40px;
  background: #d64000;
  border: none;
  border-radius: 4px;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.424;
  color: #ffffff;
  cursor: pointer;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);
  transition: background 0.2s;
}

.WVyxNp:hover:not(:disabled) {
  background: #b83800;
}

.WVyxNp:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dAT43b {
  margin-right: 4px;
}

.ShdYd4 {
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.CgQWat {
  margin: 0;
  max-width: none;
  width: auto;
}

.B_StLR {
  background: transparent;
  border: none;
  border-radius: 0;
  box-shadow: none;
  padding: 0;
}

.kxkZLH {
  background-color: rgba(0, 0, 0, 0.5);
}

.kdjJvS {
  position: absolute;
  top: 16px;
  right: 16px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #666666;
  transition: color 0.2s;
}

.kdjJvS:hover {
  color: #1f1f1f;
}

.j8TMOi {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 24px;
  text-align: center;
  min-height: 200px;
}

.vySXq6 {
  margin-top: 16px;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: #666666;
}

.DwQsgn {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 48px 24px 24px;
  text-align: center;
}

.COmPhq {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #ffeee5;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 24px;
}

.k1keO5 {
  width: 16px;
  height: 16px;
}

.M5q4qG {
  font-weight: 600;
  font-size: 20px;
  line-height: 1.4;
  color: #1f1f1f;
  margin: 0 0 12px 0;
}

.P2yN2T,
.ojzOTb {
  font-weight: 400;
  font-size: 14px;
  line-height: 1.5;
  color: #666666;
}

.ojzOTb {
  margin: 0 0 24px 0;
  white-space: pre-line;
}

@media (max-width: 480px) {
  .G_G5uT {
    width: 100%;
    max-width: 400px;
  }

  .CgQWat {
    margin: 16px;
  }

  .SYVTpT {
    width: 40px;
    height: 44px;
    font-size: 18px;
  }

  .IvbnWX {
    gap: 6px;
  }
}
`, "",{"version":3,"sources":["webpack://./../../packages/shared-ui/src/components/PinCreationModal/PinCreationModal.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;EAC/C,wCAAwC;AAC1C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,QAAQ;EACR,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,OAAO;AACT;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,SAAS;EACT,aAAa;AACf;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb;;wBAEsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,2CAA2C;AAC7C;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,oBAAoB;EACpB,SAAS;EACT,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,2CAA2C;EAC3C,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,QAAQ;EACV;AACF","sourcesContent":[".pinCreationContainer {\n  display: flex;\n  flex-direction: column;\n  width: 400px;\n  background: #ffffff;\n  border: 1px solid #e6e6e6;\n  border-radius: 8px;\n  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);\n  font-family: 'Source Sans 3', sans-serif;\n}\n\n.header {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 8px;\n  width: 100%;\n  padding: 24px 24px 0px;\n}\n\n.title {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.424;\n  color: #1f1f1f;\n  margin: 0;\n  flex: 1;\n}\n\n.description {\n  margin: 0;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #666666;\n}\n\n.pinFieldsContainer {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  gap: 24px;\n  padding: 24px;\n}\n\n.pinField {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.pinLabel {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  width: 100%;\n  margin-bottom: 8px;\n}\n\n.pinLabelText {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.421;\n  color: #1f1f1f;\n  margin: 0;\n}\n\n.infoIcon {\n  cursor: help;\n  width: 12px !important;\n  height: 12px !important;\n}\n\n.pinInputContainer {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  width: 100%;\n  justify-content: flex-start;\n}\n\n.pinDigit {\n  width: 44px;\n  height: 48px;\n  text-align: center;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1;\n  color: #1f1f1f;\n  background: #fafafa;\n  border: 1px solid #cccccc;\n  border-radius: 4px;\n  outline: none;\n  transition:\n    border-color 0.2s ease,\n    box-shadow 0.2s ease;\n}\n\n.pinDigit:focus {\n  border-color: #d64000;\n  box-shadow: 0 0 0 2px rgba(214, 64, 0, 0.1);\n}\n\n.pinDigit.error {\n  border-color: #dc3545;\n  background-color: #fff5f5;\n}\n\n.pinDigit.filled {\n  border-color: #999999;\n}\n\n.pinDigit:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.errorMessage {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding-top: 12px;\n  max-width: 80%;\n}\n\n.errorIcon {\n  width: 16px;\n  height: 16px;\n  color: #dc3545;\n  flex-shrink: 0;\n  margin-top: 2px;\n}\n\n.errorText {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 1.4;\n  color: #666666;\n  margin: 0;\n}\n\n.generalErrorMessage {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  padding: 12px 24px;\n}\n\n.buttonsContainer {\n  display: flex;\n  justify-content: stretch;\n  align-items: stretch;\n  gap: 16px;\n  padding: 0px 24px 24px;\n  width: 100%;\n}\n\n.confirmButton {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 0;\n  width: 100%;\n  height: 40px;\n  background: #d64000;\n  border: none;\n  border-radius: 4px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.424;\n  color: #ffffff;\n  cursor: pointer;\n  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12);\n  transition: background 0.2s;\n}\n\n.confirmButton:hover:not(:disabled) {\n  background: #b83800;\n}\n\n.confirmButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.loadingSpinner {\n  margin-right: 4px;\n}\n\n.modal {\n  display: flex !important;\n  align-items: center;\n  justify-content: center;\n}\n\n.modalDialog {\n  margin: 0;\n  max-width: none;\n  width: auto;\n}\n\n.modalContent {\n  background: transparent;\n  border: none;\n  border-radius: 0;\n  box-shadow: none;\n  padding: 0;\n}\n\n.backdrop {\n  background-color: rgba(0, 0, 0, 0.5);\n}\n\n.closeButton {\n  position: absolute;\n  top: 16px;\n  right: 16px;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #666666;\n  transition: color 0.2s;\n}\n\n.closeButton:hover {\n  color: #1f1f1f;\n}\n\n.loadingContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 48px 24px;\n  text-align: center;\n  min-height: 200px;\n}\n\n.loadingText {\n  margin-top: 16px;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #666666;\n}\n\n.successContent {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 48px 24px 24px;\n  text-align: center;\n}\n\n.successIconWrapper {\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: #ffeee5;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 24px;\n}\n\n.successIcon {\n  width: 16px;\n  height: 16px;\n}\n\n.successTitle {\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.4;\n  color: #1f1f1f;\n  margin: 0 0 12px 0;\n}\n\n.successDescriptionPart1,\n.successDescriptionPart2 {\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.5;\n  color: #666666;\n}\n\n.successDescriptionPart2 {\n  margin: 0 0 24px 0;\n  white-space: pre-line;\n}\n\n@media (max-width: 480px) {\n  .pinCreationContainer {\n    width: 100%;\n    max-width: 400px;\n  }\n\n  .modalDialog {\n    margin: 16px;\n  }\n\n  .pinDigit {\n    width: 40px;\n    height: 44px;\n    font-size: 18px;\n  }\n\n  .pinInputContainer {\n    gap: 6px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pinCreationContainer": `G_G5uT`,
	"header": `NT48yd`,
	"title": `fP56gb`,
	"description": `set303`,
	"pinFieldsContainer": `yKBB4J`,
	"pinField": `K03vGt`,
	"pinLabel": `uCZWVD`,
	"pinLabelText": `DEp9mH`,
	"infoIcon": `b4wsKn`,
	"pinInputContainer": `IvbnWX`,
	"pinDigit": `SYVTpT`,
	"error": `CN6QQV`,
	"filled": `S9E8Iu`,
	"errorMessage": `FxqBGc`,
	"errorIcon": `VatNr0`,
	"errorText": `IbbIwT`,
	"generalErrorMessage": `I3RgJ5`,
	"buttonsContainer": `OloaDu`,
	"confirmButton": `WVyxNp`,
	"loadingSpinner": `dAT43b`,
	"modal": `ShdYd4`,
	"modalDialog": `CgQWat`,
	"modalContent": `B_StLR`,
	"backdrop": `kxkZLH`,
	"closeButton": `kdjJvS`,
	"loadingContent": `j8TMOi`,
	"loadingText": `vySXq6`,
	"successContent": `DwQsgn`,
	"successIconWrapper": `COmPhq`,
	"successIcon": `k1keO5`,
	"successTitle": `M5q4qG`,
	"successDescriptionPart1": `P2yN2T`,
	"successDescriptionPart2": `ojzOTb`
};
module.exports = ___CSS_LOADER_EXPORT___;
